module.exports = __webpack_public_path__ + "static/media/Gengar_gaussian2.e7d251ed.png";